import { Avatar, makeStyles, Typography } from "@material-ui/core";

import { useUserLocalProjectsQuery } from "modules/projects/hooks/queries/useUserLocalProjectsQuery";
import { useSelectedProject } from "modules/projects/hooks/useSelectedProject";
import { useAuthUserQuery } from "modules/user/hooks/queries/useAuthUserQuery";
import { useActiveAccount } from "modules/core/hooks/useActiveAccount";

import HStack from "modules/core/components/HStack";
import RoleChip from "../../user-management/RoleChip";
import UsersIndicator from "../../UsersIndicator";

const useStyles = makeStyles(theme => ({
  userCard: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    padding: "10px 15px",
    justifyContent: "space-between",
    marginBottom: 10
  }
}));

const WorkspaceStep = () => {
  const { data: userData } = useAuthUserQuery();
  const { data: userProjects } = useUserLocalProjectsQuery();

  const { activeAccount } = useActiveAccount();
  const { selectedProject, isSingleProject } = useSelectedProject();

  const master = activeAccount?.master;

  const userRole = isSingleProject
    ? selectedProject?.user_role?.[0]
    : userData?.best_role;

  const classes = useStyles();

  return (
    <div>
      <Typography
        variant="body2"
        color="textSecondary"
        style={{ marginBottom: 15 }}
      >
        You have been invited to join a new project at{" "}
        <strong>{activeAccount?.name}</strong>. Below is more information about
        your role & workspace
      </Typography>

      <HStack className={classes.userCard}>
        <HStack gap={10}>
          <Avatar src={userData?.avatar}>
            {userData?.name?.at(0)?.toUpperCase()}
          </Avatar>

          <div>
            <Typography variant="subtitle1" style={{ lineHeight: 1.5 }}>
              {userData?.name} {userData?.surname}
            </Typography>

            <Typography
              variant="caption"
              color="textSecondary"
              style={{ lineHeight: 1 }}
              component="p"
            >
              Invited to join <strong>{userProjects?.length} projects</strong>
            </Typography>
          </div>
        </HStack>

        {userRole ? <RoleChip role={userRole} /> : null}
      </HStack>

      <HStack style={{ justifyContent: "space-between" }}>
        <Typography variant="caption">
          <strong>Workspace Owner:</strong> {master?.name}
        </Typography>

        <UsersIndicator hideAddButton avatarSize={30} />
      </HStack>
    </div>
  );
};

export default WorkspaceStep;
